// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2639":"b16f4d06","3383":"a3c70498","4799":"b16f4d06","6520":"b16f4d06","7330":"b16f4d06"}[chunkId] + ".chunk.css";
};